export interface paths {
    '/api/v1/organizations/{organizationId}/documents': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['DocumentsCreateDocumentTransfer'];
                    'application/json': components['schemas']['DocumentsCreateDocumentTransfer'];
                    'text/json': components['schemas']['DocumentsCreateDocumentTransfer'];
                    'application/*+json': components['schemas']['DocumentsCreateDocumentTransfer'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['DocumentsFullDocumentAnswer'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/documents/{documentId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    documentId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/documents/{documentId}/images': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    documentId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'multipart/form-data': {
                        /** @description ImageSide: front, back, face */
                        imageSide: string;
                        fileName: string;
                        /** Format: binary */
                        fileContent: Blob;
                    };
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['DocumentsFullDocumentImageAnswer'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['FormGetFormAnswer'];
                    };
                };
            };
        };
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['FormUpdateFormTransfer'];
                    'application/json': components['schemas']['FormUpdateFormTransfer'];
                    'text/json': components['schemas']['FormUpdateFormTransfer'];
                    'application/*+json': components['schemas']['FormUpdateFormTransfer'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['FormGetFormAnswer'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/submit': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/persons/{personId}': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    personId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['PersonsPersonAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    personId: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/persons': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['PersonsUpdatePersonTransfer'];
                    'application/json': components['schemas']['PersonsUpdatePersonTransfer'];
                    'text/json': components['schemas']['PersonsUpdatePersonTransfer'];
                    'application/*+json': components['schemas']['PersonsUpdatePersonTransfer'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['PersonsPersonAnswer'][];
                    };
                };
            };
        };
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['PersonsCreatePersonTransfer'];
                    'application/json': components['schemas']['PersonsCreatePersonTransfer'];
                    'text/json': components['schemas']['PersonsCreatePersonTransfer'];
                    'application/*+json': components['schemas']['PersonsCreatePersonTransfer'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['PersonsPersonAnswer'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/organizations/{organizationId}/persons/{personId}/invitation-emails': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    organizationId: string;
                    personId: string;
                };
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['PersonsSendPersonInvitationEmailTransfer'];
                    'application/json': components['schemas']['PersonsSendPersonInvitationEmailTransfer'];
                    'text/json': components['schemas']['PersonsSendPersonInvitationEmailTransfer'];
                    'application/*+json': components['schemas']['PersonsSendPersonInvitationEmailTransfer'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/ping': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    'api-version'?: string;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/references/supported-currencies': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ReferenceGetSupportedCurrenciesAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/references/business-countries': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ReferenceGetBusinessCountriesAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/references/person-countries': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: {
                    permittedJurisdiction?: boolean;
                };
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ReferenceGetPersonCountriesAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/references/countries/{countryCode}/person-document-types': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path: {
                    countryCode: string;
                };
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['ReferenceCountryDocumentTypesAnswer'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/persons': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'application/json-patch+json': components['schemas']['TokenPartialPersonDataTransfer'];
                    'application/json': components['schemas']['TokenPartialPersonDataTransfer'];
                    'text/json': components['schemas']['TokenPartialPersonDataTransfer'];
                    'application/*+json': components['schemas']['TokenPartialPersonDataTransfer'];
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
            };
        };
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/images': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: {
                content: {
                    'multipart/form-data': {
                        documentType: string;
                        /** @description ImageSide: front, back, face */
                        imageSide: string;
                        fileName: string;
                        /** Format: binary */
                        fileContent: Blob;
                    };
                };
            };
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/person-tokens/status': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['TokenTokenStatusAnswer'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
            };
        };
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/end-client-application/submitted': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    '/api/v1/webhooks/end-client-application/decisioned': {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: {
            parameters: {
                query?: never;
                header?: never;
                path?: never;
                cookie?: never;
            };
            requestBody?: never;
            responses: {
                /** @description OK */
                200: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
                /** @description Bad Request */
                400: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Unauthorized */
                401: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content: {
                        'application/json': components['schemas']['MicrosoftAspNetCoreMvcProblemDetails'];
                    };
                };
                /** @description Internal Server Error */
                500: {
                    headers: {
                        [name: string]: unknown;
                    };
                    content?: never;
                };
            };
        };
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /**
         * Format: string
         * @description <ul><li><i>AD</i></li><li><i>AE</i></li><li><i>AF</i></li><li><i>AG</i></li><li><i>AI</i></li><li><i>AL</i></li><li><i>AM</i></li><li><i>AO</i></li><li><i>AQ</i></li><li><i>AR</i></li><li><i>AS</i></li><li><i>AT</i></li><li><i>AU</i></li><li><i>AW</i></li><li><i>AX</i></li><li><i>AZ</i></li><li><i>BA</i></li><li><i>BB</i></li><li><i>BD</i></li><li><i>BE</i></li><li><i>BF</i></li><li><i>BG</i></li><li><i>BH</i></li><li><i>BI</i></li><li><i>BJ</i></li><li><i>BL</i></li><li><i>BM</i></li><li><i>BN</i></li><li><i>BO</i></li><li><i>BQ</i></li><li><i>BR</i></li><li><i>BS</i></li><li><i>BT</i></li><li><i>BV</i></li><li><i>BW</i></li><li><i>BY</i></li><li><i>BZ</i></li><li><i>CA</i></li><li><i>CC</i></li><li><i>CD</i></li><li><i>CF</i></li><li><i>CG</i></li><li><i>CH</i></li><li><i>CI</i></li><li><i>CK</i></li><li><i>CL</i></li><li><i>CM</i></li><li><i>CN</i></li><li><i>CO</i></li><li><i>CR</i></li><li><i>CU</i></li><li><i>CV</i></li><li><i>CW</i></li><li><i>CX</i></li><li><i>CY</i></li><li><i>CZ</i></li><li><i>DE</i></li><li><i>DJ</i></li><li><i>DK</i></li><li><i>DM</i></li><li><i>DO</i></li><li><i>DZ</i></li><li><i>EC</i></li><li><i>EE</i></li><li><i>EG</i></li><li><i>EH</i></li><li><i>ER</i></li><li><i>ES</i></li><li><i>ET</i></li><li><i>FI</i></li><li><i>FJ</i></li><li><i>FK</i></li><li><i>FM</i></li><li><i>FO</i></li><li><i>FR</i></li><li><i>GA</i></li><li><i>GB</i></li><li><i>GD</i></li><li><i>GE</i></li><li><i>GF</i></li><li><i>GG</i></li><li><i>GH</i></li><li><i>GI</i></li><li><i>GL</i></li><li><i>GM</i></li><li><i>GN</i></li><li><i>GP</i></li><li><i>GQ</i></li><li><i>GR</i></li><li><i>GS</i></li><li><i>GT</i></li><li><i>GU</i></li><li><i>GW</i></li><li><i>GY</i></li><li><i>HK</i></li><li><i>HM</i></li><li><i>HN</i></li><li><i>HR</i></li><li><i>HT</i></li><li><i>HU</i></li><li><i>ID</i></li><li><i>IE</i></li><li><i>IL</i></li><li><i>IM</i></li><li><i>IN</i></li><li><i>IO</i></li><li><i>IQ</i></li><li><i>IR</i></li><li><i>IS</i></li><li><i>IT</i></li><li><i>JE</i></li><li><i>JM</i></li><li><i>JO</i></li><li><i>JP</i></li><li><i>KE</i></li><li><i>KG</i></li><li><i>KH</i></li><li><i>KI</i></li><li><i>KM</i></li><li><i>KN</i></li><li><i>KP</i></li><li><i>KR</i></li><li><i>KW</i></li><li><i>KY</i></li><li><i>KZ</i></li><li><i>LA</i></li><li><i>LB</i></li><li><i>LC</i></li><li><i>LI</i></li><li><i>LK</i></li><li><i>LR</i></li><li><i>LS</i></li><li><i>LT</i></li><li><i>LU</i></li><li><i>LV</i></li><li><i>LY</i></li><li><i>MA</i></li><li><i>MC</i></li><li><i>MD</i></li><li><i>ME</i></li><li><i>MF</i></li><li><i>MG</i></li><li><i>MH</i></li><li><i>MK</i></li><li><i>ML</i></li><li><i>MM</i></li><li><i>MN</i></li><li><i>MO</i></li><li><i>MP</i></li><li><i>MQ</i></li><li><i>MR</i></li><li><i>MS</i></li><li><i>MT</i></li><li><i>MU</i></li><li><i>MV</i></li><li><i>MW</i></li><li><i>MX</i></li><li><i>MY</i></li><li><i>MZ</i></li><li><i>NA</i></li><li><i>NC</i></li><li><i>NE</i></li><li><i>NF</i></li><li><i>NG</i></li><li><i>NI</i></li><li><i>NL</i></li><li><i>NO</i></li><li><i>NP</i></li><li><i>NR</i></li><li><i>NU</i></li><li><i>NZ</i></li><li><i>OM</i></li><li><i>PA</i></li><li><i>PE</i></li><li><i>PF</i></li><li><i>PG</i></li><li><i>PH</i></li><li><i>PK</i></li><li><i>PL</i></li><li><i>PM</i></li><li><i>PN</i></li><li><i>PR</i></li><li><i>PS</i></li><li><i>PT</i></li><li><i>PW</i></li><li><i>PY</i></li><li><i>QA</i></li><li><i>RE</i></li><li><i>RO</i></li><li><i>RS</i></li><li><i>RU</i></li><li><i>RW</i></li><li><i>SA</i></li><li><i>SB</i></li><li><i>SC</i></li><li><i>SD</i></li><li><i>SE</i></li><li><i>SG</i></li><li><i>SH</i></li><li><i>SI</i></li><li><i>SJ</i></li><li><i>SK</i></li><li><i>SL</i></li><li><i>SM</i></li><li><i>SN</i></li><li><i>SO</i></li><li><i>SR</i></li><li><i>SS</i></li><li><i>ST</i></li><li><i>SV</i></li><li><i>SX</i></li><li><i>SY</i></li><li><i>SZ</i></li><li><i>TC</i></li><li><i>TD</i></li><li><i>TF</i></li><li><i>TG</i></li><li><i>TH</i></li><li><i>TJ</i></li><li><i>TK</i></li><li><i>TL</i></li><li><i>TM</i></li><li><i>TN</i></li><li><i>TO</i></li><li><i>TR</i></li><li><i>TT</i></li><li><i>TV</i></li><li><i>TW</i></li><li><i>TZ</i></li><li><i>UA</i></li><li><i>UG</i></li><li><i>UM</i></li><li><i>US</i></li><li><i>UY</i></li><li><i>UZ</i></li><li><i>VA</i></li><li><i>VC</i></li><li><i>VE</i></li><li><i>VG</i></li><li><i>VI</i></li><li><i>VN</i></li><li><i>VU</i></li><li><i>WF</i></li><li><i>WS</i></li><li><i>XK</i></li><li><i>YE</i></li><li><i>YT</i></li><li><i>ZA</i></li><li><i>ZM</i></li><li><i>ZW</i></li></ul>
         * @enum {string}
         */
        CountryIsoCode: CountryIsoCode;
        /**
         * Format: string
         * @description <ul><li><i>ADA</i></li><li><i>AED</i></li><li><i>AFN</i></li><li><i>ALL</i></li><li><i>AMD</i></li><li><i>ANG</i></li><li><i>AOA</i></li><li><i>ARS</i></li><li><i>AUD</i></li><li><i>AWG</i></li><li><i>AZN</i></li><li><i>BAM</i></li><li><i>BBD</i></li><li><i>BCH</i></li><li><i>BDT</i></li><li><i>BGN</i></li><li><i>BHD</i></li><li><i>BIF</i></li><li><i>BMD</i></li><li><i>BNB</i></li><li><i>BND</i></li><li><i>BOB</i></li><li><i>BRL</i></li><li><i>BSD</i></li><li><i>BTC</i></li><li><i>BTN</i></li><li><i>BWP</i></li><li><i>BYN</i></li><li><i>BYR</i></li><li><i>BZD</i></li><li><i>CAD</i></li><li><i>CDF</i></li><li><i>CHE</i></li><li><i>CHF</i></li><li><i>CHW</i></li><li><i>CLF</i></li><li><i>CLP</i></li><li><i>CNY</i></li><li><i>COP</i></li><li><i>COU</i></li><li><i>CRC</i></li><li><i>CUC</i></li><li><i>CUP</i></li><li><i>CVE</i></li><li><i>CZK</i></li><li><i>DJF</i></li><li><i>DKK</i></li><li><i>DOGE</i></li><li><i>DOP</i></li><li><i>DZD</i></li><li><i>EEK</i></li><li><i>EGP</i></li><li><i>ERN</i></li><li><i>ETB</i></li><li><i>ETC</i></li><li><i>ETH</i></li><li><i>EUR</i></li><li><i>FJD</i></li><li><i>FKP</i></li><li><i>GBP</i></li><li><i>GEL</i></li><li><i>GHS</i></li><li><i>GIP</i></li><li><i>GMD</i></li><li><i>GNF</i></li><li><i>GTQ</i></li><li><i>GYD</i></li><li><i>HKD</i></li><li><i>HNL</i></li><li><i>HRK</i></li><li><i>HTG</i></li><li><i>HUF</i></li><li><i>IDR</i></li><li><i>ILS</i></li><li><i>INR</i></li><li><i>IQD</i></li><li><i>IRR</i></li><li><i>ISK</i></li><li><i>JMD</i></li><li><i>JOD</i></li><li><i>JPY</i></li><li><i>KES</i></li><li><i>KGS</i></li><li><i>KHR</i></li><li><i>KMF</i></li><li><i>KPW</i></li><li><i>KRW</i></li><li><i>KTD</i></li><li><i>KWD</i></li><li><i>KYD</i></li><li><i>KZT</i></li><li><i>LAK</i></li><li><i>LBP</i></li><li><i>LEO</i></li><li><i>LINK</i></li><li><i>LKR</i></li><li><i>LRD</i></li><li><i>LSL</i></li><li><i>LTC</i></li><li><i>LTL</i></li><li><i>LVL</i></li><li><i>LYD</i></li><li><i>MAD</i></li><li><i>MDL</i></li><li><i>MGA</i></li><li><i>MKD</i></li><li><i>MMK</i></li><li><i>MNT</i></li><li><i>MOP</i></li><li><i>MRO</i></li><li><i>MRU</i></li><li><i>MUR</i></li><li><i>MVR</i></li><li><i>MWK</i></li><li><i>MXN</i></li><li><i>MXV</i></li><li><i>MYR</i></li><li><i>MZN</i></li><li><i>NAD</i></li><li><i>NGN</i></li><li><i>NIO</i></li><li><i>NOK</i></li><li><i>NPR</i></li><li><i>NZD</i></li><li><i>OMR</i></li><li><i>PAB</i></li><li><i>PEN</i></li><li><i>PGK</i></li><li><i>PHP</i></li><li><i>PKR</i></li><li><i>PLN</i></li><li><i>PYG</i></li><li><i>QAR</i></li><li><i>RON</i></li><li><i>RSD</i></li><li><i>RUB</i></li><li><i>RWF</i></li><li><i>SAR</i></li><li><i>SBD</i></li><li><i>SCR</i></li><li><i>SDG</i></li><li><i>SEK</i></li><li><i>SGD</i></li><li><i>SHP</i></li><li><i>SKK</i></li><li><i>SLE</i></li><li><i>SLL</i></li><li><i>SOS</i></li><li><i>SRD</i></li><li><i>SSP</i></li><li><i>STD</i></li><li><i>STN</i></li><li><i>SVC</i></li><li><i>SYP</i></li><li><i>SZL</i></li><li><i>THB</i></li><li><i>TJS</i></li><li><i>TMT</i></li><li><i>TND</i></li><li><i>TOP</i></li><li><i>TRX</i></li><li><i>TRY</i></li><li><i>TTD</i></li><li><i>TWD</i></li><li><i>TZS</i></li><li><i>UAH</i></li><li><i>UGX</i></li><li><i>USD</i></li><li><i>USDT</i></li><li><i>UYU</i></li><li><i>UZS</i></li><li><i>VEF</i></li><li><i>VES</i></li><li><i>VND</i></li><li><i>VUV</i></li><li><i>WST</i></li><li><i>XAF</i></li><li><i>XCD</i></li><li><i>XLM</i></li><li><i>XMR</i></li><li><i>XOF</i></li><li><i>XPF</i></li><li><i>XRP</i></li><li><i>YER</i></li><li><i>ZAR</i></li><li><i>ZMK</i></li><li><i>ZMW</i></li><li><i>ZWD</i></li><li><i>ZWL</i></li></ul>
         * @enum {string}
         */
        CurrencyIsoCode: CurrencyIsoCode;
        /**
         * Format: string
         * @description <ul><li><i>ProofOfAddress</i> - proof_of_address</li><li><i>ProofOfBusinessActivity</i> - proof_of_business_activity</li><li><i>ProofOfBusinessIdentity</i> - proof_of_business_identity</li><li><i>ProofOfDirectors</i> - proof_of_directors</li><li><i>ProofOfIdentity</i> - proof_of_identity</li><li><i>ProofOfOwners</i> - proof_of_owners</li><li><i>ProofOfSourceOfFunds</i> - proof_of_source_of_funds</li><li><i>Supporting</i> - supporting</li></ul>
         * @enum {string}
         */
        DocumentCategory: DocumentCategory;
        /**
         * Format: string
         * @description <ul><li><i>BankStatement</i> - bank_statement</li><li><i>BiometricStateId</i> - biometric_state_id</li><li><i>DrivingLicence</i> - driving_licence</li><li><i>Mortgage</i> - mortgage</li><li><i>Passport</i> - passport</li><li><i>ProofOfBusinessActivity</i> - proof_of_business_activity</li><li><i>ProofOfBusinessIdentity</i> - proof_of_business_identity</li><li><i>ProofOfDirectors</i> - proof_of_directors</li><li><i>ProofOfOwners</i> - proof_of_owners</li><li><i>ProofOfSourceOfFunds</i> - proof_of_source_of_funds</li><li><i>ResidenceId</i> - residence_id</li><li><i>StateId</i> - state_id</li><li><i>Supporting</i> - supporting</li><li><i>Unknown</i> - unknown</li><li><i>UtilityBill</i> - utility_bill</li><li><i>Visa</i> - visa</li></ul>
         * @enum {string}
         */
        DocumentType: DocumentType;
        DocumentsCreateDocumentTransfer: {
            documentType: components['schemas']['DocumentType'];
            documentCategory: components['schemas']['DocumentCategory'];
        };
        DocumentsDocumentAnswer: {
            /** Format: uuid */
            id: string;
            type: components['schemas']['DocumentType'];
            category: components['schemas']['DocumentCategory'];
            documentImages: components['schemas']['DocumentsDocumentImageAnswer'][];
        };
        DocumentsDocumentImageAnswer: {
            /** Format: uuid */
            id: string;
            imageSide: components['schemas']['ImageSide'];
            name: string;
        };
        DocumentsFullDocumentAnswer: {
            /** Format: uuid */
            documentId: string;
            documentType: components['schemas']['DocumentType'];
            documentCategory: components['schemas']['DocumentCategory'];
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            updatedAt?: string | null;
        };
        DocumentsFullDocumentImageAnswer: {
            /** Format: uuid */
            documentId: string;
            /** Format: uuid */
            documentImageId: string;
            imageSide: components['schemas']['ImageSide'];
            fileName: string;
            extension: string;
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            updatedAt?: string | null;
        };
        FormAccountUsageAnswer: {
            documents: components['schemas']['DocumentsDocumentAnswer'][];
            collectionsAccount?: boolean | null;
            primaryPurpose?: components['schemas']['PrimaryPurpose'];
            sourceOfFunds?: components['schemas']['SourceOfFunds'];
            collectionCurrencies: components['schemas']['CurrencyIsoCode'][];
            paymentCurrencies: components['schemas']['CurrencyIsoCode'][];
            transactionCountries: components['schemas']['CountryIsoCode'][];
            estimatedMonthlyTransactionCurrency?: components['schemas']['CurrencyIsoCode'];
            /** Format: int32 */
            estimatedMonthlyTransactionValue?: number | null;
            /** Format: int32 */
            estimatedMonthlyTransactionVolume?: number | null;
            initialCapital?: string | null;
            purposeDetails?: string | null;
            otherSourceOfFunds?: string | null;
        };
        FormAccountUsageTransfer: {
            documentIds?: string[] | null;
            collectionsAccount?: boolean | null;
            primaryPurpose?: components['schemas']['PrimaryPurpose'];
            sourceOfFunds?: components['schemas']['SourceOfFunds'];
            collectionCurrencies: components['schemas']['CurrencyIsoCode'][];
            paymentCurrencies: components['schemas']['CurrencyIsoCode'][];
            transactionCountries: components['schemas']['CountryIsoCode'][];
            estimatedMonthlyTransactionCurrency?: components['schemas']['CurrencyIsoCode'];
            /** Format: int32 */
            estimatedMonthlyTransactionValue?: number | null;
            /** Format: int32 */
            estimatedMonthlyTransactionVolume?: number | null;
            initialCapital?: string | null;
            purposeDetails?: string | null;
            otherSourceOfFunds?: string | null;
        };
        FormAdditionalDocumentsAnswer: {
            documents: components['schemas']['DocumentsDocumentAnswer'][];
        };
        FormAdditionalDocumentsTransfer: {
            documentIds: string[];
        };
        FormAddressModel: {
            city?: string | null;
            street?: string | null;
            country?: components['schemas']['CountryIsoCode'];
            postalCode?: string | null;
            buildingNumber?: string | null;
            buildingName?: string | null;
            apartmentNumber?: string | null;
            state?: string | null;
        };
        FormBusinessInformationAnswer: {
            documents: components['schemas']['DocumentsDocumentAnswer'][];
            businessCountry?: components['schemas']['CountryIsoCode'];
            companyName?: string | null;
            tradingName?: string | null;
            legalEntityType?: components['schemas']['LegalEntityType'];
            sector?: components['schemas']['Sector'];
            companyRegistrationNumber?: string | null;
            vatNumber?: string | null;
            /** Format: date */
            incorporationDate?: string | null;
            businessWebsite?: string | null;
            noBusinessWebsite?: boolean | null;
            areCompanyAddressesEqual?: boolean | null;
            registeredAddress?: components['schemas']['FormAddressModel'];
            tradingAddress?: components['schemas']['FormAddressModel'];
            businessActivityDescription?: string | null;
        };
        FormBusinessInformationTransfer: {
            documentIds: string[];
            businessCountry?: components['schemas']['CountryIsoCode'];
            companyName?: string | null;
            tradingName?: string | null;
            legalEntityType?: components['schemas']['LegalEntityType'];
            sector?: components['schemas']['Sector'];
            companyRegistrationNumber?: string | null;
            vatNumber?: string | null;
            /** Format: date */
            incorporationDate?: string | null;
            businessWebsite?: string | null;
            noBusinessWebsite?: boolean | null;
            areCompanyAddressesEqual?: boolean | null;
            registeredAddress?: components['schemas']['FormAddressModel'];
            tradingAddress?: components['schemas']['FormAddressModel'];
            businessActivityDescription?: string | null;
        };
        FormContactDetailsModel: {
            agreedToMarketingEmails?: boolean | null;
            agreedToTermsAndConditions?: boolean | null;
            country?: components['schemas']['CountryIsoCode'];
            contactName?: string | null;
            /** Format: email */
            email?: string | null;
            phoneNumber?: string | null;
            agreedToCorporateAuthority?: boolean | null;
        };
        FormDataAnswer: {
            contactDetails?: components['schemas']['FormContactDetailsModel'];
            accountUsage?: components['schemas']['FormAccountUsageAnswer'];
            businessInformation?: components['schemas']['FormBusinessInformationAnswer'];
            people?: components['schemas']['FormPeopleAnswer'];
            additionalDocuments?: components['schemas']['FormAdditionalDocumentsAnswer'];
        };
        FormDataTransfer: {
            contactDetails?: components['schemas']['FormContactDetailsModel'];
            accountUsage?: components['schemas']['FormAccountUsageTransfer'];
            businessInformation?: components['schemas']['FormBusinessInformationTransfer'];
            additionalDocuments?: components['schemas']['FormAdditionalDocumentsTransfer'];
        };
        FormGetFormAnswer: {
            status: components['schemas']['FormStage'];
            /** Format: date-time */
            createdAt: string;
            /** Format: date-time */
            updatedAt: string;
            /** Format: uuid */
            submittedBy?: string | null;
            /** Format: date-time */
            submittedAt?: string | null;
            data?: components['schemas']['FormDataAnswer'];
        };
        FormPeopleAnswer: {
            persons: components['schemas']['PersonsPersonAnswer'][];
        };
        /**
         * Format: string
         * @description <ul><li><i>Approved</i> - approved</li><li><i>Draft</i> - draft</li><li><i>Rejected</i> - rejected</li><li><i>Submitted</i> - submitted</li></ul>
         * @enum {string}
         */
        FormStage: FormStage;
        FormUpdateFormTransfer: {
            data: components['schemas']['FormDataTransfer'];
        };
        /**
         * Format: string
         * @description <ul><li><i>Back</i> - back</li><li><i>Face</i> - face</li><li><i>Front</i> - front</li></ul>
         * @enum {string}
         */
        ImageSide: ImageSide;
        /**
         * Format: string
         * @description <ul><li><i>Details</i> - details</li><li><i>Document</i> - document</li><li><i>Selfie</i> - selfie</li></ul>
         */
        InitialPersonFillingStep: string;
        /**
         * Format: string
         * @description <ul><li><i>CompanyWithNomineeShareholdersOrSharesInBearerForm</i> - company_with_nominee_shareholders_or_shares_in_bearer_form</li><li><i>LimitedLiabilityCompany</i> - limited_liability_company</li><li><i>LimitedLiabilityPartnership</i> - limited_liability_partnership</li><li><i>Other</i> - other</li><li><i>PublicLimitedCompany</i> - public_limited_company</li><li><i>RegisteredCharity</i> - registered_charity</li><li><i>ScottishLimitedPartnership</i> - scottish_limited_partnership</li><li><i>Trust</i> - trust</li><li><i>UnincorporatedPartnership</i> - unincorporated_partnership</li><li><i>UnregisteredCharity</i> - unregistered_charity</li></ul>
         * @enum {string}
         */
        LegalEntityType: LegalEntityType;
        MicrosoftAspNetCoreMvcProblemDetails: {
            type?: string | null;
            title?: string | null;
            /** Format: int32 */
            status?: number | null;
            detail?: string | null;
            instance?: string | null;
        } & {
            [key: string]: unknown;
        };
        /**
         * Format: string
         * @description <ul><li><i>InvitationSent</i></li><li><i>NotReady</i></li><li><i>Ready</i></li></ul>
         * @enum {string}
         */
        PersonFormState: PersonFormState;
        PersonsCreatePersonTransfer: {
            person: components['schemas']['PersonsPersonTransfer'];
        };
        PersonsPersonAnswer: {
            documents: components['schemas']['DocumentsDocumentAnswer'][];
            personFormState: components['schemas']['PersonFormState'];
            /** Format: date-time */
            submittedAt?: string | null;
            roles: components['schemas']['Role'][];
            firstName: string;
            middleName?: string | null;
            lastName: string;
            /** Format: date */
            dob?: string | null;
            phoneNumber?: string | null;
            /** Format: email */
            email?: string | null;
            homeCountry?: components['schemas']['CountryIsoCode'];
            address?: components['schemas']['FormAddressModel'];
            /** Format: double */
            ownershipPercentage?: number | null;
            idNumber?: string | null;
            passportNumber?: string | null;
            passportCountryOfIssue?: components['schemas']['CountryIsoCode'];
            verifyNeeded: boolean;
            isWalletOwner: boolean;
            /** Format: uuid */
            userId?: string | null;
            /** Format: uuid */
            personId?: string | null;
        };
        PersonsPersonTransfer: {
            documentIds: string[];
            roles: components['schemas']['Role'][];
            firstName: string;
            middleName?: string | null;
            lastName: string;
            /** Format: date */
            dob?: string | null;
            phoneNumber?: string | null;
            /** Format: email */
            email?: string | null;
            homeCountry?: components['schemas']['CountryIsoCode'];
            address?: components['schemas']['FormAddressModel'];
            /** Format: double */
            ownershipPercentage?: number | null;
            idNumber?: string | null;
            passportNumber?: string | null;
            passportCountryOfIssue?: components['schemas']['CountryIsoCode'];
            verifyNeeded: boolean;
            isWalletOwner: boolean;
            /** Format: uuid */
            userId?: string | null;
            /** Format: uuid */
            personId?: string | null;
        };
        PersonsSendPersonInvitationEmailTransfer: {
            initialStep: components['schemas']['InitialPersonFillingStep'];
        };
        PersonsUpdatePersonTransfer: {
            persons: components['schemas']['PersonsPersonTransfer'][];
        };
        /**
         * Format: string
         * @description <ul><li><i>CollectingFundsFromClients</i> - collecting_funds_from_clients</li><li><i>IntercompanyTransfers</i> - intercompany_transfers</li><li><i>InvestmentActivity</i> - investment_activity</li><li><i>LiquidityFx</i> - liquidity_fx</li><li><i>LiquidityOrFx</i> - liquidity_or_fx</li><li><i>Other</i> - other</li><li><i>PayingAnIndividual</i> - paying_an_individual</li><li><i>PayingSuppliersOrBills</i> - paying_suppliers_or_bills</li><li><i>PaymentToAnIndividual</i> - payment_to_an_individual</li><li><i>PropertyPurchaseOrSale</i> - property_purchase_or_sale</li><li><i>RepatriatingOverseasEarnings</i> - repatriating_overseas_earnings</li></ul>
         * @enum {string}
         */
        PrimaryPurpose: PrimaryPurpose;
        ReferenceBusinessCountryModel: {
            countryCode: string;
            countryName: string;
            eeaCountry: boolean;
            isPermittedJurisdiction: boolean;
        };
        ReferenceCountryDocumentTypesAnswer: {
            items: components['schemas']['DocumentType'][];
        };
        ReferenceCurrencyModel: {
            currencyIsoCode: components['schemas']['CurrencyIsoCode'];
            currencyName: string;
            countryOrRegionCode: string;
        };
        ReferenceGetBusinessCountriesAnswer: {
            items: components['schemas']['ReferenceBusinessCountryModel'][];
        };
        ReferenceGetPersonCountriesAnswer: {
            items: components['schemas']['ReferencePersonCountryModel'][];
        };
        ReferenceGetSupportedCurrenciesAnswer: {
            items: components['schemas']['ReferenceCurrencyModel'][];
        };
        ReferencePersonCountryModel: {
            countryCode: string;
            countryName: string;
            isPermittedJurisdiction: boolean;
            documentTypes: components['schemas']['DocumentType'][];
        };
        /**
         * Format: string
         * @description <ul><li><i>Director</i> - director</li><li><i>UltimateBusinessOwner</i> - ultimate_business_owner</li><li><i>User</i> - user</li></ul>
         * @enum {string}
         */
        Role: Role;
        /**
         * Format: string
         * @description <ul><li><i>Accountancy</i> - accountancy</li><li><i>AdultEntertainment</i> - adult_entertainment</li><li><i>AdultProducts</i> - adult_products</li><li><i>AdvertisingOrPublicRelationsOrMarketing</i> - advertising_or_public_relations_or_marketing</li><li><i>Aerospace</i> - aerospace</li><li><i>Agricultural</i> - agricultural</li><li><i>Architecture</i> - architecture</li><li><i>AssetOrWealthManagementOrWealthTech</i> - asset_or_wealth_management_or_wealth_tech</li><li><i>AutomobileOrCarParts</i> - automobile_or_car_parts</li><li><i>Banking</i> - banking</li><li><i>BarsOrRestaurants</i> - bars_or_restaurants</li><li><i>BioSciencesOrBeautyProducts</i> - bio_sciences_or_beauty_products</li><li><i>BooksOrMagazinesAndNewspapers</i> - books_or_magazines_and_newspapers</li><li><i>Broker</i> - broker</li><li><i>BrokerDealer</i> - broker_dealer</li><li><i>BuildingMaterialsAndEquipment</i> - building_materials_and_equipment</li><li><i>CallCentres</i> - call_centres</li><li><i>CasinosOrGambling</i> - casinos_or_gambling</li><li><i>ChemicalAndRelatedManufacturing</i> - chemical_and_related_manufacturing</li><li><i>ClothingOrTextiles</i> - clothing_or_textiles</li><li><i>ComputerOrCyberSecurity</i> - computer_or_cyber_security</li><li><i>ComputerSoftware</i> - computer_software</li><li><i>Construction</i> - construction</li><li><i>CourierOrExpressOrParcel</i> - courier_or_express_or_parcel</li><li><i>Cryptoassets</i> - cryptoassets</li><li><i>DataStorageOrProcessing</i> - data_storage_or_processing</li><li><i>ElectronicEquipmentOrMobilePhones</i> - electronic_equipment_or_mobile_phones</li><li><i>Engineering</i> - engineering</li><li><i>EstateOrLettingAgency</i> - estate_or_letting_agency</li><li><i>EtailorOrEcommerce</i> - etailor_or_ecommerce</li><li><i>FitnessEquipment</i> - fitness_equipment</li><li><i>FoodAndBeverage</i> - food_and_beverage</li><li><i>ForestryAndForestProducts</i> - forestry_and_forest_products</li><li><i>FreightOrLogistics</i> - freight_or_logistics</li><li><i>Fund</i> - fund</li><li><i>FurnitureAndFlooring</i> - furniture_and_flooring</li><li><i>Gaming</i></li><li><i>HedgeFundOrFamilyOffice</i> - hedge_fund_or_family_office</li><li><i>HighValueGoods</i> - high_value_goods</li><li><i>HistoricalOrCulturalArtefacts</i> - historical_or_cultural_artefacts</li><li><i>HospitalityOrEventsOrConferences</i> - hospitality_or_events_or_conferences</li><li><i>HospitalsAndCareFacilities</i> - hospitals_and_care_facilities</li><li><i>Hotels</i> - hotels</li><li><i>InsuranceOrInsureTech</i> - insurance_or_insure_tech</li><li><i>InteriorDesign</i> - interior_design</li><li><i>ITManagedServices</i> - it_managed_services</li><li><i>Legal</i> - legal</li><li><i>LoanCompany</i> - loan_company</li><li><i>LoggingTimberAndPaperMills</i> - logging_timber_and_paper_mills</li><li><i>MachineryAndToolsOrIndustrialEquipment</i> - machinery_and_tools_or_industrial_equipment</li><li><i>MiningOrExtractiveIndustries</i> - mining_or_extractive_industries</li><li><i>MoneyServicesBusiness</i> - money_services_business</li><li><i>MultiLevelMarketing</i> - multi_level_marketing</li><li><i>MusicProduction</i> - music_production</li><li><i>NutritionalOrDietarySupplements</i> - nutritional_or_dietary_supplements</li><li><i>OilAndGas</i> - oil_and_gas</li><li><i>OnlineMarketingOrBranding</i> - online_marketing_or_branding</li><li><i>OtherConsultancy</i> - other_consultancy</li><li><i>Packaging</i> - packaging</li><li><i>PawnBrokers</i> - pawn_brokers</li><li><i>PayrollCompanyOrPayTech</i> - payroll_company_or_pay_tech</li><li><i>PharmaceuticalsOrMedicalDevices</i> - pharmaceuticals_or_medical_devices</li><li><i>PoliticalGroupOrLobbying</i> - political_group_or_lobbying</li><li><i>PreciousMetals</i> - precious_metals</li><li><i>PrivateEquityOrInvestmentFirmOrVentureCapital</i> - private_equity_or_investment_firm_or_venture_capital</li><li><i>PropertyDevelopment</i> - property_development</li><li><i>RadioOrTVBroadcaster</i> - radio_or_tv_broadcaster</li><li><i>RealEstateInvestment</i> - real_estate_investment</li><li><i>Recruitment</i> - recruitment</li><li><i>RegisteredCharity</i> - registered_charity</li><li><i>RegulatedOnlineMarketplaceOrPlatform</i> - regulated_online_marketplace_or_platform</li><li><i>SchoolsAndUniversities</i> - schools_and_universities</li><li><i>Security</i> - security</li><li><i>SpeculativeTrading</i> - speculative_trading</li><li><i>SportingOrProfessionalClub</i> - sporting_or_professional_club</li><li><i>TaxAdvisers</i> - tax_advisers</li><li><i>TaxiOrPrivateTransport</i> - taxi_or_private_transport</li><li><i>Telecoms</i> - telecoms</li><li><i>TobaccoOrAlcohol</i> - tobacco_or_alcohol</li><li><i>Transportation</i> - transportation</li><li><i>TravelAgentOrTravelWebsite</i> - travel_agent_or_travel_website</li><li><i>TrustAndCompanyFormationProviders</i> - trust_and_company_formation_providers</li><li><i>TrustCompany</i> - trust_company</li><li><i>UnregisteredCharity</i> - unregistered_charity</li><li><i>Utilities</i> - utilities</li><li><i>WasteManagementOrRecycling</i> - waste_management_or_recycling</li><li><i>WeaponsAndMilitaryEquipment</i> - weapons_and_military_equipment</li><li><i>WebsiteOrAppDevelopment</i> - website_or_app_development</li></ul>
         * @enum {string}
         */
        Sector: Sector;
        /**
         * Format: string
         * @description <ul><li><i>BusinessRevenue</i> - business_revenue</li><li><i>DonationsOrGrants</i> - donations_or_grants</li><li><i>ExternalInvestment</i> - external_investment</li><li><i>InterCompanyTransfers</i> - inter_company_transfers</li><li><i>Loan</i> - loan</li><li><i>Other</i> - other</li><li><i>SaleOfAssets</i> - sale_of_assets</li></ul>
         * @enum {string}
         */
        SourceOfFunds: SourceOfFunds;
        TokenPartialPersonDataTransfer: {
            /** Format: date */
            dob?: string | null;
            phoneNumber?: string | null;
            address?: components['schemas']['FormAddressModel'];
            idNumber?: string | null;
            passportNumber?: string | null;
            passportCountryOfIssue?: components['schemas']['CountryIsoCode'];
        };
        /**
         * Format: string
         * @description <ul><li><i>Invalid</i> - invalid</li><li><i>Valid</i> - valid</li></ul>
         * @enum {string}
         */
        TokenStatus: TokenStatus;
        TokenTokenStatusAnswer: {
            tokenStatus: components['schemas']['TokenStatus'];
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export enum CountryIsoCode {
    AD = 'AD',
    AE = 'AE',
    AF = 'AF',
    AG = 'AG',
    AI = 'AI',
    AL = 'AL',
    AM = 'AM',
    AO = 'AO',
    AQ = 'AQ',
    AR = 'AR',
    AS = 'AS',
    AT = 'AT',
    AU = 'AU',
    AW = 'AW',
    AX = 'AX',
    AZ = 'AZ',
    BA = 'BA',
    BB = 'BB',
    BD = 'BD',
    BE = 'BE',
    BF = 'BF',
    BG = 'BG',
    BH = 'BH',
    BI = 'BI',
    BJ = 'BJ',
    BL = 'BL',
    BM = 'BM',
    BN = 'BN',
    BO = 'BO',
    BQ = 'BQ',
    BR = 'BR',
    BS = 'BS',
    BT = 'BT',
    BV = 'BV',
    BW = 'BW',
    BY = 'BY',
    BZ = 'BZ',
    CA = 'CA',
    CC = 'CC',
    CD = 'CD',
    CF = 'CF',
    CG = 'CG',
    CH = 'CH',
    CI = 'CI',
    CK = 'CK',
    CL = 'CL',
    CM = 'CM',
    CN = 'CN',
    CO = 'CO',
    CR = 'CR',
    CU = 'CU',
    CV = 'CV',
    CW = 'CW',
    CX = 'CX',
    CY = 'CY',
    CZ = 'CZ',
    DE = 'DE',
    DJ = 'DJ',
    DK = 'DK',
    DM = 'DM',
    DO = 'DO',
    DZ = 'DZ',
    EC = 'EC',
    EE = 'EE',
    EG = 'EG',
    EH = 'EH',
    ER = 'ER',
    ES = 'ES',
    ET = 'ET',
    FI = 'FI',
    FJ = 'FJ',
    FK = 'FK',
    FM = 'FM',
    FO = 'FO',
    FR = 'FR',
    GA = 'GA',
    GB = 'GB',
    GD = 'GD',
    GE = 'GE',
    GF = 'GF',
    GG = 'GG',
    GH = 'GH',
    GI = 'GI',
    GL = 'GL',
    GM = 'GM',
    GN = 'GN',
    GP = 'GP',
    GQ = 'GQ',
    GR = 'GR',
    GS = 'GS',
    GT = 'GT',
    GU = 'GU',
    GW = 'GW',
    GY = 'GY',
    HK = 'HK',
    HM = 'HM',
    HN = 'HN',
    HR = 'HR',
    HT = 'HT',
    HU = 'HU',
    ID = 'ID',
    IE = 'IE',
    IL = 'IL',
    IM = 'IM',
    IN = 'IN',
    IO = 'IO',
    IQ = 'IQ',
    IR = 'IR',
    IS = 'IS',
    IT = 'IT',
    JE = 'JE',
    JM = 'JM',
    JO = 'JO',
    JP = 'JP',
    KE = 'KE',
    KG = 'KG',
    KH = 'KH',
    KI = 'KI',
    KM = 'KM',
    KN = 'KN',
    KP = 'KP',
    KR = 'KR',
    KW = 'KW',
    KY = 'KY',
    KZ = 'KZ',
    LA = 'LA',
    LB = 'LB',
    LC = 'LC',
    LI = 'LI',
    LK = 'LK',
    LR = 'LR',
    LS = 'LS',
    LT = 'LT',
    LU = 'LU',
    LV = 'LV',
    LY = 'LY',
    MA = 'MA',
    MC = 'MC',
    MD = 'MD',
    ME = 'ME',
    MF = 'MF',
    MG = 'MG',
    MH = 'MH',
    MK = 'MK',
    ML = 'ML',
    MM = 'MM',
    MN = 'MN',
    MO = 'MO',
    MP = 'MP',
    MQ = 'MQ',
    MR = 'MR',
    MS = 'MS',
    MT = 'MT',
    MU = 'MU',
    MV = 'MV',
    MW = 'MW',
    MX = 'MX',
    MY = 'MY',
    MZ = 'MZ',
    NA = 'NA',
    NC = 'NC',
    NE = 'NE',
    NF = 'NF',
    NG = 'NG',
    NI = 'NI',
    NL = 'NL',
    NO = 'NO',
    NP = 'NP',
    NR = 'NR',
    NU = 'NU',
    NZ = 'NZ',
    OM = 'OM',
    PA = 'PA',
    PE = 'PE',
    PF = 'PF',
    PG = 'PG',
    PH = 'PH',
    PK = 'PK',
    PL = 'PL',
    PM = 'PM',
    PN = 'PN',
    PR = 'PR',
    PS = 'PS',
    PT = 'PT',
    PW = 'PW',
    PY = 'PY',
    QA = 'QA',
    RE = 'RE',
    RO = 'RO',
    RS = 'RS',
    RU = 'RU',
    RW = 'RW',
    SA = 'SA',
    SB = 'SB',
    SC = 'SC',
    SD = 'SD',
    SE = 'SE',
    SG = 'SG',
    SH = 'SH',
    SI = 'SI',
    SJ = 'SJ',
    SK = 'SK',
    SL = 'SL',
    SM = 'SM',
    SN = 'SN',
    SO = 'SO',
    SR = 'SR',
    SS = 'SS',
    ST = 'ST',
    SV = 'SV',
    SX = 'SX',
    SY = 'SY',
    SZ = 'SZ',
    TC = 'TC',
    TD = 'TD',
    TF = 'TF',
    TG = 'TG',
    TH = 'TH',
    TJ = 'TJ',
    TK = 'TK',
    TL = 'TL',
    TM = 'TM',
    TN = 'TN',
    TO = 'TO',
    TR = 'TR',
    TT = 'TT',
    TV = 'TV',
    TW = 'TW',
    TZ = 'TZ',
    UA = 'UA',
    UG = 'UG',
    UM = 'UM',
    US = 'US',
    UY = 'UY',
    UZ = 'UZ',
    VA = 'VA',
    VC = 'VC',
    VE = 'VE',
    VG = 'VG',
    VI = 'VI',
    VN = 'VN',
    VU = 'VU',
    WF = 'WF',
    WS = 'WS',
    XK = 'XK',
    YE = 'YE',
    YT = 'YT',
    ZA = 'ZA',
    ZM = 'ZM',
    ZW = 'ZW',
}
export enum CurrencyIsoCode {
    ADA = 'ADA',
    AED = 'AED',
    AFN = 'AFN',
    ALL = 'ALL',
    AMD = 'AMD',
    ANG = 'ANG',
    AOA = 'AOA',
    ARS = 'ARS',
    AUD = 'AUD',
    AWG = 'AWG',
    AZN = 'AZN',
    BAM = 'BAM',
    BBD = 'BBD',
    BCH = 'BCH',
    BDT = 'BDT',
    BGN = 'BGN',
    BHD = 'BHD',
    BIF = 'BIF',
    BMD = 'BMD',
    BNB = 'BNB',
    BND = 'BND',
    BOB = 'BOB',
    BRL = 'BRL',
    BSD = 'BSD',
    BTC = 'BTC',
    BTN = 'BTN',
    BWP = 'BWP',
    BYN = 'BYN',
    BYR = 'BYR',
    BZD = 'BZD',
    CAD = 'CAD',
    CDF = 'CDF',
    CHE = 'CHE',
    CHF = 'CHF',
    CHW = 'CHW',
    CLF = 'CLF',
    CLP = 'CLP',
    CNY = 'CNY',
    COP = 'COP',
    COU = 'COU',
    CRC = 'CRC',
    CUC = 'CUC',
    CUP = 'CUP',
    CVE = 'CVE',
    CZK = 'CZK',
    DJF = 'DJF',
    DKK = 'DKK',
    DOGE = 'DOGE',
    DOP = 'DOP',
    DZD = 'DZD',
    EEK = 'EEK',
    EGP = 'EGP',
    ERN = 'ERN',
    ETB = 'ETB',
    ETC = 'ETC',
    ETH = 'ETH',
    EUR = 'EUR',
    FJD = 'FJD',
    FKP = 'FKP',
    GBP = 'GBP',
    GEL = 'GEL',
    GHS = 'GHS',
    GIP = 'GIP',
    GMD = 'GMD',
    GNF = 'GNF',
    GTQ = 'GTQ',
    GYD = 'GYD',
    HKD = 'HKD',
    HNL = 'HNL',
    HRK = 'HRK',
    HTG = 'HTG',
    HUF = 'HUF',
    IDR = 'IDR',
    ILS = 'ILS',
    INR = 'INR',
    IQD = 'IQD',
    IRR = 'IRR',
    ISK = 'ISK',
    JMD = 'JMD',
    JOD = 'JOD',
    JPY = 'JPY',
    KES = 'KES',
    KGS = 'KGS',
    KHR = 'KHR',
    KMF = 'KMF',
    KPW = 'KPW',
    KRW = 'KRW',
    KTD = 'KTD',
    KWD = 'KWD',
    KYD = 'KYD',
    KZT = 'KZT',
    LAK = 'LAK',
    LBP = 'LBP',
    LEO = 'LEO',
    LINK = 'LINK',
    LKR = 'LKR',
    LRD = 'LRD',
    LSL = 'LSL',
    LTC = 'LTC',
    LTL = 'LTL',
    LVL = 'LVL',
    LYD = 'LYD',
    MAD = 'MAD',
    MDL = 'MDL',
    MGA = 'MGA',
    MKD = 'MKD',
    MMK = 'MMK',
    MNT = 'MNT',
    MOP = 'MOP',
    MRO = 'MRO',
    MRU = 'MRU',
    MUR = 'MUR',
    MVR = 'MVR',
    MWK = 'MWK',
    MXN = 'MXN',
    MXV = 'MXV',
    MYR = 'MYR',
    MZN = 'MZN',
    NAD = 'NAD',
    NGN = 'NGN',
    NIO = 'NIO',
    NOK = 'NOK',
    NPR = 'NPR',
    NZD = 'NZD',
    OMR = 'OMR',
    PAB = 'PAB',
    PEN = 'PEN',
    PGK = 'PGK',
    PHP = 'PHP',
    PKR = 'PKR',
    PLN = 'PLN',
    PYG = 'PYG',
    QAR = 'QAR',
    RON = 'RON',
    RSD = 'RSD',
    RUB = 'RUB',
    RWF = 'RWF',
    SAR = 'SAR',
    SBD = 'SBD',
    SCR = 'SCR',
    SDG = 'SDG',
    SEK = 'SEK',
    SGD = 'SGD',
    SHP = 'SHP',
    SKK = 'SKK',
    SLE = 'SLE',
    SLL = 'SLL',
    SOS = 'SOS',
    SRD = 'SRD',
    SSP = 'SSP',
    STD = 'STD',
    STN = 'STN',
    SVC = 'SVC',
    SYP = 'SYP',
    SZL = 'SZL',
    THB = 'THB',
    TJS = 'TJS',
    TMT = 'TMT',
    TND = 'TND',
    TOP = 'TOP',
    TRX = 'TRX',
    TRY = 'TRY',
    TTD = 'TTD',
    TWD = 'TWD',
    TZS = 'TZS',
    UAH = 'UAH',
    UGX = 'UGX',
    USD = 'USD',
    USDT = 'USDT',
    UYU = 'UYU',
    UZS = 'UZS',
    VEF = 'VEF',
    VES = 'VES',
    VND = 'VND',
    VUV = 'VUV',
    WST = 'WST',
    XAF = 'XAF',
    XCD = 'XCD',
    XLM = 'XLM',
    XMR = 'XMR',
    XOF = 'XOF',
    XPF = 'XPF',
    XRP = 'XRP',
    YER = 'YER',
    ZAR = 'ZAR',
    ZMK = 'ZMK',
    ZMW = 'ZMW',
    ZWD = 'ZWD',
    ZWL = 'ZWL',
}
export enum DocumentCategory {
    proof_of_address = 'proof_of_address',
    proof_of_business_activity = 'proof_of_business_activity',
    proof_of_business_identity = 'proof_of_business_identity',
    proof_of_directors = 'proof_of_directors',
    proof_of_identity = 'proof_of_identity',
    proof_of_owners = 'proof_of_owners',
    proof_of_source_of_funds = 'proof_of_source_of_funds',
    supporting = 'supporting',
}
export enum DocumentType {
    bank_statement = 'bank_statement',
    biometric_state_id = 'biometric_state_id',
    driving_licence = 'driving_licence',
    mortgage = 'mortgage',
    passport = 'passport',
    proof_of_business_activity = 'proof_of_business_activity',
    proof_of_business_identity = 'proof_of_business_identity',
    proof_of_directors = 'proof_of_directors',
    proof_of_owners = 'proof_of_owners',
    proof_of_source_of_funds = 'proof_of_source_of_funds',
    residence_id = 'residence_id',
    state_id = 'state_id',
    supporting = 'supporting',
    unknown = 'unknown',
    utility_bill = 'utility_bill',
    visa = 'visa',
}
export enum FormStage {
    approved = 'approved',
    draft = 'draft',
    rejected = 'rejected',
    submitted = 'submitted',
}
export enum ImageSide {
    back = 'back',
    face = 'face',
    front = 'front',
}
export enum LegalEntityType {
    company_with_nominee_shareholders_or_shares_in_bearer_form = 'company_with_nominee_shareholders_or_shares_in_bearer_form',
    limited_liability_company = 'limited_liability_company',
    limited_liability_partnership = 'limited_liability_partnership',
    other = 'other',
    public_limited_company = 'public_limited_company',
    registered_charity = 'registered_charity',
    scottish_limited_partnership = 'scottish_limited_partnership',
    trust = 'trust',
    unincorporated_partnership = 'unincorporated_partnership',
    unregistered_charity = 'unregistered_charity',
}
export enum PersonFormState {
    InvitationSent = 'InvitationSent',
    NotReady = 'NotReady',
    Ready = 'Ready',
}
export enum PrimaryPurpose {
    collecting_funds_from_clients = 'collecting_funds_from_clients',
    intercompany_transfers = 'intercompany_transfers',
    investment_activity = 'investment_activity',
    liquidity_fx = 'liquidity_fx',
    liquidity_or_fx = 'liquidity_or_fx',
    other = 'other',
    paying_an_individual = 'paying_an_individual',
    paying_suppliers_or_bills = 'paying_suppliers_or_bills',
    payment_to_an_individual = 'payment_to_an_individual',
    property_purchase_or_sale = 'property_purchase_or_sale',
    repatriating_overseas_earnings = 'repatriating_overseas_earnings',
}
export enum Role {
    director = 'director',
    ultimate_business_owner = 'ultimate_business_owner',
    user = 'user',
}
export enum Sector {
    accountancy = 'accountancy',
    adult_entertainment = 'adult_entertainment',
    adult_products = 'adult_products',
    advertising_or_public_relations_or_marketing = 'advertising_or_public_relations_or_marketing',
    aerospace = 'aerospace',
    agricultural = 'agricultural',
    architecture = 'architecture',
    asset_or_wealth_management_or_wealth_tech = 'asset_or_wealth_management_or_wealth_tech',
    automobile_or_car_parts = 'automobile_or_car_parts',
    banking = 'banking',
    bars_or_restaurants = 'bars_or_restaurants',
    bio_sciences_or_beauty_products = 'bio_sciences_or_beauty_products',
    books_or_magazines_and_newspapers = 'books_or_magazines_and_newspapers',
    broker = 'broker',
    broker_dealer = 'broker_dealer',
    building_materials_and_equipment = 'building_materials_and_equipment',
    call_centres = 'call_centres',
    casinos_or_gambling = 'casinos_or_gambling',
    chemical_and_related_manufacturing = 'chemical_and_related_manufacturing',
    clothing_or_textiles = 'clothing_or_textiles',
    computer_or_cyber_security = 'computer_or_cyber_security',
    computer_software = 'computer_software',
    construction = 'construction',
    courier_or_express_or_parcel = 'courier_or_express_or_parcel',
    cryptoassets = 'cryptoassets',
    data_storage_or_processing = 'data_storage_or_processing',
    electronic_equipment_or_mobile_phones = 'electronic_equipment_or_mobile_phones',
    engineering = 'engineering',
    estate_or_letting_agency = 'estate_or_letting_agency',
    etailor_or_ecommerce = 'etailor_or_ecommerce',
    fitness_equipment = 'fitness_equipment',
    food_and_beverage = 'food_and_beverage',
    forestry_and_forest_products = 'forestry_and_forest_products',
    freight_or_logistics = 'freight_or_logistics',
    fund = 'fund',
    furniture_and_flooring = 'furniture_and_flooring',
    Gaming = 'Gaming',
    hedge_fund_or_family_office = 'hedge_fund_or_family_office',
    high_value_goods = 'high_value_goods',
    historical_or_cultural_artefacts = 'historical_or_cultural_artefacts',
    hospitality_or_events_or_conferences = 'hospitality_or_events_or_conferences',
    hospitals_and_care_facilities = 'hospitals_and_care_facilities',
    hotels = 'hotels',
    insurance_or_insure_tech = 'insurance_or_insure_tech',
    interior_design = 'interior_design',
    it_managed_services = 'it_managed_services',
    legal = 'legal',
    loan_company = 'loan_company',
    logging_timber_and_paper_mills = 'logging_timber_and_paper_mills',
    machinery_and_tools_or_industrial_equipment = 'machinery_and_tools_or_industrial_equipment',
    mining_or_extractive_industries = 'mining_or_extractive_industries',
    money_services_business = 'money_services_business',
    multi_level_marketing = 'multi_level_marketing',
    music_production = 'music_production',
    nutritional_or_dietary_supplements = 'nutritional_or_dietary_supplements',
    oil_and_gas = 'oil_and_gas',
    online_marketing_or_branding = 'online_marketing_or_branding',
    other_consultancy = 'other_consultancy',
    packaging = 'packaging',
    pawn_brokers = 'pawn_brokers',
    payroll_company_or_pay_tech = 'payroll_company_or_pay_tech',
    pharmaceuticals_or_medical_devices = 'pharmaceuticals_or_medical_devices',
    political_group_or_lobbying = 'political_group_or_lobbying',
    precious_metals = 'precious_metals',
    private_equity_or_investment_firm_or_venture_capital = 'private_equity_or_investment_firm_or_venture_capital',
    property_development = 'property_development',
    radio_or_tv_broadcaster = 'radio_or_tv_broadcaster',
    real_estate_investment = 'real_estate_investment',
    recruitment = 'recruitment',
    registered_charity = 'registered_charity',
    regulated_online_marketplace_or_platform = 'regulated_online_marketplace_or_platform',
    schools_and_universities = 'schools_and_universities',
    security = 'security',
    speculative_trading = 'speculative_trading',
    sporting_or_professional_club = 'sporting_or_professional_club',
    tax_advisers = 'tax_advisers',
    taxi_or_private_transport = 'taxi_or_private_transport',
    telecoms = 'telecoms',
    tobacco_or_alcohol = 'tobacco_or_alcohol',
    transportation = 'transportation',
    travel_agent_or_travel_website = 'travel_agent_or_travel_website',
    trust_and_company_formation_providers = 'trust_and_company_formation_providers',
    trust_company = 'trust_company',
    unregistered_charity = 'unregistered_charity',
    utilities = 'utilities',
    waste_management_or_recycling = 'waste_management_or_recycling',
    weapons_and_military_equipment = 'weapons_and_military_equipment',
    website_or_app_development = 'website_or_app_development',
}
export enum SourceOfFunds {
    business_revenue = 'business_revenue',
    donations_or_grants = 'donations_or_grants',
    external_investment = 'external_investment',
    inter_company_transfers = 'inter_company_transfers',
    loan = 'loan',
    other = 'other',
    sale_of_assets = 'sale_of_assets',
}
export enum TokenStatus {
    invalid = 'invalid',
    valid = 'valid',
}
export type operations = Record<string, never>;
